import React from "react";

const SectionHeader = ({ title, description, children }) => {
  return (
    <div className="flex justify-between sm:items-center items-start max-sm:flex-col">
      <div>
        {Boolean(title) && (
          <h2 className="text-lg font-semibold text-gray-900 p-0 m-0">
            {title}
          </h2>
        )}

        {Boolean(description) && (
          <p className="text-sm font-normal text-gray-600 p-0 m-0">
            {description}
          </p>
        )}
      </div>

      {Boolean(children) && (
        <div className="mt-4 sm:mt-0 w-full sm:w-auto">{children}</div>
      )}
    </div>
  );
};

export default SectionHeader;
